export const getLoginPath = (productPath: string): string =>
  `${productPath}/login`;

export const getDefaultPath = (productPath: string): string =>
  `${productPath}/`;
